<template>
  <div
    :class="{ loader: true, fadeout: !isLoading }"
    class="d-flex flex-column justify-center align-center splash"
  >
    <img :src="ObtenerLogo" alt="logo" class="logo-cmv" />
    <div v-if="mostrarCargando">
      <v-progress-circular
        indeterminate
        color="white"
        class="mt-5"
      ></v-progress-circular>
      <p class="font-weight-bold">Cargando...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  props: ['isLoading', 'mostrarCargando'],
  computed: {
    ObtenerLogo() {
      return require('@/assets/images/LogotipoVSF.png')
    },
  },
}
</script>

<style>
.loader {
  /* background: linear-gradient(45deg, #77b82a 60%, #bfd600); */
  background: #77b82a; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    45deg,
    #008743,
    #78b800
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    45deg,
    #008743,
    #78b800
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  bottom: 0;
  color: white;
  display: block;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}

.logo-cmv {
  width: 190px;
}

.fadeout {
  animation: fadeout 2s forwards;
}

.splash {
  max-height: 100vh;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
